import { ReactNode, createContext } from "react";
import { AuthProvider } from "../Authentication/AuthContext";
import { LoadingProvider } from "../Loading/LoadingContext";

interface GlobalProviderProps {
  children: ReactNode;
}

export const GlobalContext = createContext({});

export function GlobalProvider({ children }: GlobalProviderProps) {
  return (
    <GlobalContext.Provider value="">
      <LoadingProvider>
        <AuthProvider>{children}</AuthProvider>
      </LoadingProvider>
    </GlobalContext.Provider>
  );
}
